<template>
  <Section
    :title="gettext('Sélectionnez l’utilisation souhaitée')"
    size="default"
  >
    <RadiosGrid
      :value="usageId"
      :field="field"
      grid-item-class="sm-w-1/2 lg-w-1/4"
      label-class="box--small md-pdg"
      @input="updateUsageId"
    >
      <template #default="slotProps">
        <Icon
          :id="slotProps.choice[1].icon"
          class="text-brand icon--150 md-icon--200"
        />
        <div class="h4 mrgt--">{{ slotProps.choice[1].name }}</div>
        <div class="text-medium text-muted">
          {{ slotProps.choice[1].description }}
        </div>
      </template>
    </RadiosGrid>
  </Section>
</template>

<script setup>
import { computed } from 'vue';
import config from '@/config/simulation';
import Section from '@/components/simulation/Section.vue';
import RadiosGrid from '@/components/forms/fields/RadiosGrid.vue';
import { useSimulation } from '@/composables/useSimulation';

const { usageId, updateUsageId } = useSimulation();

const field = computed(() => {
  return {
    label: gettext('Utilisation'),
    name: 'usage',
    choices: Object.keys(config.usages).map((key) => {
      const val = config.usages[key];
      return [key, val];
    }),
  };
});
</script>
